module.exports = __webpack_public_path__ + "public/images/generated-american-history.9c7d06f245d6f4d55e1bddb9a8afdfe3.jpg";